module.exports = __webpack_public_path__ + "img/amedrontada.cbb3f876.png";